import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Typography } from 'antd';
import heatmapChart from './configs/heatmapChart';

function HeatmapChart({
  title = 'Daily Performance',
  paragraph = '',
  percentage = '',
  options = heatmapChart.options,
  series = [],
  height = 350,
  width = '100%',
}) {
  const { Title, Paragraph } = Typography;
  return (
    <>
      <div className='heatmapchart'>
        <div>
          <Title level={5}>{title}</Title>
          <Paragraph className='lastweek'>
            {paragraph}
            <span className='bnb2'>{percentage}</span>
          </Paragraph>
        </div>
      </div>

      <div className='full-width'>
        <ReactApexChart
          options={options}
          series={series}
          type='heatmap'
          height={height}
          width={width}
        />
      </div>
    </>
  );
}

export default HeatmapChart;
